import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { Http } from '@angular/http';
import { ModalController } from 'ionic-angular';
import config from '../../config/config';
import {AcompanharPage} from '../acompanhar/acompanhar';


/**
 * Generated class for the ExtrairPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-extrair',
  templateUrl: 'extrair.html',
})
export class ExtrairPage {
  form={
  'email':'',
  'password':''

};
loading = null;

  constructor(public navCtrl: NavController,
     public navParams: NavParams,
     public loadingCtrl: LoadingController,
     private alertCtrl: AlertController,
    public _http: Http,
    public modalCtrl : ModalController) {
  }
  ngOnInit(){
 let egresso=localStorage.getItem('egresso');
 if (egresso == 'teste') {
           this.navCtrl.setRoot(AcompanharPage);
 }else{
    localStorage.clear();
   
 }

  }
  carregando(){
      this.loading = this.loadingCtrl.create({
    content: 'Enviando.'
  });
  this.loading.present();
  }
  logar(form){
    console.log(form)
    this.carregando();
     this._http 
        .post(config.urlAPI+"login",form,{})
        .map(res => res.json())
        .toPromise()
        .then(res => {
          console.log(res.success);
          if (!res.success && res.success !=undefined) {
            this.loading.dismiss();
            let alert = this.alertCtrl.create({
              title: 'Login não Autorizado',
              message: 'Login ou Senha incorreto !!',
              buttons: [
                            {
                text: 'ok',
                handler: () => {
                  // this.navCtrl.setRoot(PerfilPage); 
                }
              }
              ],
              enableBackdropDismiss: false
              });
              alert.present();
              return true
          }
          localStorage.clear();
            localStorage.setItem('id', res.id);
            localStorage.setItem('email', res.email);
            localStorage.setItem('egresso', 'teste');
           this.loading.dismiss();
           this.navCtrl.setRoot(AcompanharPage);
        }).catch(error => {
          this.loading.dismiss();
          let alert = this.alertCtrl.create({
            title: 'Login não Autorizado',
            message: 'Login ou Senha incorreto !!',
            buttons: [
                          {
              text: 'OK',
              handler: () => {
                // this.navCtrl.setRoot(PerfilPage); 
              }
            }
            ],
            enableBackdropDismiss: false
            });
            alert.present();
          // console.log(error);

        });
  }



}



// WEBPACK FOOTER //
// ./src/pages/extrair/extrair.ts